/**
 * Holds the short-lived access token in memory only (never localStorage), so
 * an XSS payload cannot exfiltrate a long-lived credential. The refresh token
 * lives in an HttpOnly cookie the browser manages.
 */
let accessToken: string | null = null;
type Listener = () => void;
const expiryListeners = new Set<Listener>();

export const tokenStore = {
  get: () => accessToken,
  set: (token: string | null) => {
    accessToken = token;
  },
  clear: () => {
    accessToken = null;
  },
  /** Notified when the session can no longer be refreshed. */
  onSessionExpired(listener: Listener) {
    expiryListeners.add(listener);
    return () => {
      expiryListeners.delete(listener);
    };
  },
  notifySessionExpired() {
    accessToken = null;
    expiryListeners.forEach((listener) => listener());
  },
};
